module.exports = __webpack_public_path__ + "static/media/regali24.b4bbfe5a.svg";